import { useRef } from 'react'

export function useCloseTimeout(props) {
  const { timeout } = props

  const timeoutRef = useRef(null)

  function handleSetCloseTimeout() {
    timeoutRef.current = setTimeout(() => {
      props.onClose?.()
    }, timeout)
  }

  function handleClearCloseTimeout() {
    clearTimeout(timeoutRef.current)
  }

  return { handleClearCloseTimeout, handleSetCloseTimeout, timeoutRef }
}
